module.exports = __webpack_public_path__ + "static/img/order-card-inner-bg.28d9d910.png";